var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import { CheckCircleIcon, XCircleIcon } from "lucide-react";
var validationMessageVariants = cva("flex justify-start items-center text-[#26226] font-semibold gap-3 h-10 sm:h-12", {
    variants: {
        variant: {
            success: "bg-green-100 border border-solid border-green-700",
            destructive: "bg-red-100 border border-solid border-red-700",
        },
        size: {
            default: "w-full max-w-[328px] py-2 px-4 sm:w-[352px] sm:py-3 rounded-md",
        },
    },
    defaultVariants: {
        variant: "success",
        size: "default",
    },
});
var ValidationMessage = React.forwardRef(function (_a, ref) {
    var className = _a.className, variant = _a.variant, size = _a.size, validated = _a.validated, message = _a.message, statusCode = _a.statusCode, props = __rest(_a, ["className", "variant", "size", "validated", "message", "statusCode"]);
    var hasMessageSetted = !(validated === undefined);
    var isInvalidStatusCodeToDisplayMessage = !(statusCode === 200 || statusCode === 422);
    if (!hasMessageSetted || isInvalidStatusCodeToDisplayMessage) {
        return _jsx("div", { className: "h-10 sm:h-12" });
    }
    if (statusCode === 200) {
        variant = "success";
    }
    else {
        variant = "destructive";
    }
    if (statusCode === 422) {
        message = "Certidão inválida";
    }
    var Icon = function () {
        return variant === "success" ? (_jsx(CheckCircleIcon, { className: "h-5 w-5 text-[#26226]" })) : (_jsx(XCircleIcon, { className: "h-5 w-5 text-[#26226]" }));
    };
    return (_jsxs("div", __assign({ className: cn(validationMessageVariants({ variant: variant, size: size, className: className })), ref: ref }, props, { children: [_jsx(Icon, {}), _jsx("span", { children: message })] })));
});
ValidationMessage.displayName = "ValidationMessage";
export { ValidationMessage, validationMessageVariants };
